import React, { useEffect, useState,useRef } from "react";
import { getFacturasPendientes } from "./services/facturasPendientes";
import { SUCCESS_GET_FACTURAS_PENDIENTES } from "./utilities/constants";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Cargando from '../../components/misc/Redirect/Cargando';
import { NumericFormat } from 'react-number-format';
import { GetDateLocal } from "../shared/utilitties/formatDate";
interface FacturasPendientes {
    fac_id: number,
    red_id: number,
    fac_sucursal: number,
    fac_numero: string,
    fac_fecha: string,
    fat_id: number,
    fac_neto: number,
    fac_impuestos: number,
    fac_iva: number,
    fac_iva_percepcion: number,
    fac_IIBB_percepcion: number,
    fac_tipo_comprobante: string,
    fac_total: number,
    fac_nro_cai: string,
    fac_vencimiento_cai: string|null,
    fac_controlador_fiscal: true,
    fac_tasa_iva: number,
    fac_diferencia: 0,
    fac_registracion: string,
    pre_cupon: number,
    fac_orig: false,
    usu_id_sso: number,
    fac_nombre_imagen: string,
    fac_log_fecha: string,
    descripcion: string,
    periodoFacturacion: string|null
}

const FacturasPendientes = () => {
  const [data, setData] = useState<FacturasPendientes[]>([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    (async () => {
      const result = await getFacturasPendientes();
      if (result.status === 200) {
        console.log(result.data.facturaPendienteDTOs)
        setData(result.data.facturaPendienteDTOs);
        setLoader(true);
      } else {
        setData([]);
        setLoader(true);
      }
    })();
  }, []);

  const formatBoolBodyTemplate = (rowStatus: any) => {
    return (
      <React.Fragment>
        {rowStatus === true ? "Si": "NO"}
      </React.Fragment>
    );
  };

  const dateBodyTemplate = (dateRow: any) => {
    return (
      <React.Fragment>
        {dateRow != null
          ? GetDateLocal(dateRow)
          : ""}
      </React.Fragment>
    );
  };
  const numericFormatBodyTemplate = (rowDataInfo: any) => {
    return (
      <React.Fragment>
        
        <NumericFormat
          value={rowDataInfo}
          displayType={"text"}
          //thousandSeparator={","}
          decimalSeparator={"."}
          //prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };

  return !loader ? (
    <Cargando />
  ) : (
    <div>
      <div className="card">
        <DataTable
          value={data}
          header="Facturas Pendientes"
          responsiveLayout="scroll"
          columnResizeMode= "expand"
          resizableColumns={true}
        >
          <Column field="fac_sucursal" header="Sucursal" />
          <Column field="fac_numero" header="Numero"></Column>
          <Column
            field="fac_fecha"
            header="Fecha"
            body={(rowData)=>dateBodyTemplate(rowData.fac_fecha)}
            resizeable={true}
          ></Column>

        <Column
            field="fat_id"
            header="Tipo Factura"
          ></Column>

          <Column
            field="fac_neto"
            header="Neto"
            body={(rowData)=>numericFormatBodyTemplate(rowData.fac_neto)}
          ></Column>
          <Column
            field="fac_impuestos"
            header="Impuestos"
            body={(rowData)=>numericFormatBodyTemplate(rowData.fac_impuestos)}
          ></Column>
          <Column
            field="fac_iva"
            header="Iva"
            body={(rowData)=>numericFormatBodyTemplate(rowData.fac_iva)}
          ></Column>
          <Column
            field="fac_iva_percepcion"
            header="IVA percepción"
            body={(rowData)=>numericFormatBodyTemplate(rowData.fac_iva_percepcion)}
          ></Column>
          <Column
            field="fac_IIBB_percepcion"
            header="IIBB percepción"
            body={(rowData)=>numericFormatBodyTemplate(rowData.fac_IIBB_percepcion)}
          ></Column>
          <Column
            field="fac_tipo_comprobante"
            header="Tipo Comprobante"
          ></Column>
          
          <Column
            field="fac_total"
            header="Total"
            body={(rowData)=>numericFormatBodyTemplate(rowData.fac_total)}
          ></Column>
          <Column
            field="fac_nro_cai"
            header="CAI"
          ></Column>
          <Column
            field="fac_vencimiento_cai"
            header="Vencimiento CAI"
            body={(rowData)=>dateBodyTemplate(rowData.fac_vencimiento_cai)}
          ></Column>
          <Column
            field="fac_controlador_fiscal"
            header="Controlador Fiscal"
            body={(rowData) => formatBoolBodyTemplate(rowData.fac_controlador_fiscal)}
          ></Column>
          <Column
          field="fac_tasa_iva"
          header="Tasa IVA"
          body={(rowData)=>numericFormatBodyTemplate(rowData.fac_tasa_iva)}
        ></Column>
        <Column
            field="fac_diferencia"
            header="Diferencia"
            body={(rowData)=>numericFormatBodyTemplate(rowData.fac_diferencia)}
          ></Column>
          <Column
            field="fac_registracion"
            header="Fecha Registración"
            body={(rowData)=>dateBodyTemplate(rowData.fac_registracion)}
          ></Column>
          <Column
            field="pre_cupon"
            header="Cupón"
          ></Column>
          <Column
            field="fac_orig"
            header="Original"
            body={(rowData) => formatBoolBodyTemplate(rowData.fac_orig)}
          ></Column>
          
          
        </DataTable>
      </div>
    </div>
  );
};

export default FacturasPendientes;
